var map = {
	"./a_land.png": "dafc",
	"./a_port.png": "0b4e",
	"./discord.png": "7911",
	"./mc.png": "15f0",
	"./mtasa.png": "c7cf",
	"./welcome.jpg": "8413",
	"./welcome.png": "5302",
	"./welcome_b.jpg": "e9c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";